import { useState } from 'react';
import PropTypes from 'prop-types';
import InfiniteList from '@comp/InfiniteList/InfiniteList';
import Dialog from '@comp/Dialog/Dialog';
import TopicGroupCard from '@comp/TopicGroupCard/TopicGroupCard';
import { fetchSeeAllTypeFeed } from '@actions/specialClasses';
import { useDispatchToStore } from '@hooks/reduxHooks';
import { toggleEnrolledCourse } from '@actions/courses';
import { pluralize } from '@utils/textHelper';

const TopicFeedBlock = ({
  goalUID,
  topicFeedBlock,
  goalkey,
  blockId,
  defaultBlockURL,
  seeAllType,
  blockType,
  goal,
  onClick,
  label
}) => {
  const dispatch = useDispatchToStore();
  const [unEnrollModalOpen, setUnEnrollModalOpen] = useState(false);
  const [courseSelected, setcourseSelected] = useState(null);

  const message =
    'This course will be removed from your schedule and you will stop receiving updates related to this course';

  const acceptOnClick = () => {
    dispatch(toggleEnrolledCourse(courseSelected, false));
    setUnEnrollModalOpen(false);
  };

  const onCloseModal = () => {
    setUnEnrollModalOpen(false);
    setcourseSelected(null);
  };

  const renderEachClass = (topic, index) => (
    <TopicGroupCard
      dispatch={dispatch}
      key={topic.uid}
      content={pluralize(topic.coursesCount, 'course')}
      color={topic.color}
      onClick={onClick}
      topology={topic}
      goal={goal}
      index={index}
      label={label}
    />
  );

  const loadMoreClasses = () => {
    return dispatch(
      fetchSeeAllTypeFeed(
        goalUID,
        blockType,
        defaultBlockURL,
        blockId,
        seeAllType,
        true
      )
    );
  };
  if (topicFeedBlock[goalkey]?.results) {
    return (
      <>
        <Dialog
          onClose={onCloseModal}
          dialogState={unEnrollModalOpen}
          heading="Are you sure you want to unenroll?"
          message={message}
          acceptLabel="Unenroll"
          rejectLabel="Cancel"
          acceptOnClick={acceptOnClick}
          rejectOnClick={onCloseModal}
        />
        <InfiniteList
          loadMore={loadMoreClasses}
          _renderItem={renderEachClass}
          data={topicFeedBlock[goalkey]}
          gridColumn="span 18"
        />
      </>
    );
  }
  return null;
};

export default TopicFeedBlock;

TopicFeedBlock.propTypes = {
  goalUID: PropTypes.string.isRequired,
  topicFeedBlock: PropTypes.objectOf(PropTypes.any).isRequired,
  blockId: PropTypes.string.isRequired,
  defaultBlockURL: PropTypes.string.isRequired,
  seeAllType: PropTypes.string.isRequired,
  blockType: PropTypes.string.isRequired,
  goalkey: PropTypes.string.isRequired,
  goal: PropTypes.objectOf(PropTypes.any).isRequired,
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired
};
